<template>
  <div class="indice">
    <div class="indice__header">
      <h1 class="indice__header__logo">CUSTOM<br />DESIGN<br />SOFTWARE</h1>
    </div>
    <div class="indice__content">
      <div class="indice__content__productos">
        <div v-for="(producto, productoIndex) in aplicacion.productos" :key="producto.cod + '-' + productoIndex"
          class="indice__content__productos__item" :class="{
            active: producto.cod == aplicacion.getProducto().cod,
          }">
          <span class="indice__content__productos__item__name">
            {{ producto.getLiteral($store.getters.getLanguage) }}
          </span>
          <span class="indice__content__productos__item__tab"></span>
        </div>
      </div>
      <div class="indice__content__modelos">
        <div class="indice__content__modelos__item" v-for="(modelo, modeloIndex) in aplicacion.getProducto().modelos"
          :key="modelo.cod + '-' + modeloIndex">
          <router-link class="indice__content__modelos__item__miniatura" :to="{
            name: 'Configurator',
            params: {
              language: $store.getters.getLanguage,
              producto: aplicacion.getProducto().cod,
              modelo: modelo.cod,
            },
          }">
            <img @load="resolveAsset($event)" :src="requireAsset(
              'miniaturas/' +
              aplicacion.getProducto().cod +
              '/' +
              modelo.cod +
              '/' +
              'miniatura.webp'
            )
              " alt="" class="indice__content__modelos__item__miniatura__image" />
          </router-link>
          <span class="indice__content__modelos__item__name">
            {{ modelo.getLiteral($store.getters.getLanguage) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Indice',
  props: {
    aplicacion: Object,
  },
};
</script>

<style lang="scss" scoped>
.indice {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;

  &__header {
    width: 100%;
    height: 110px;
    padding: 15px;

    &__logo {
      color: black;
      font-size: 35px;
      line-height: 26px;
      font-weight: 700;
    }
  }

  &__content {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: calc(100% - 110px);
    gap: 15px;

    &__productos {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      width: 300px;
      height: 100%;
      padding: 0px 0px 15px 15px;

      &__item {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        gap: 15px;

        &__name {
          opacity: 0.5;
          font-weight: 600;
          width: 75%;
          -webkit-transition: 0.35s ease-in-out opacity;
          -moz-transition: 0.35s ease-in-out opacity;
          -ms-transition: 0.35s ease-in-out opacity;
          -o-transition: 0.35s ease-in-out opacity;
          transition: 0.35s ease-in-out opacity;
        }

        &__tab {
          width: 5px;
          height: 100%;
          background-color: transparent;
          -webkit-transition: 0.35s ease-in-out background-color;
          -moz-transition: 0.35s ease-in-out background-color;
          -ms-transition: 0.35s ease-in-out background-color;
          -o-transition: 0.35s ease-in-out background-color;
          transition: 0.35s ease-in-out background-color;
        }

        &.active {
          & .indice__content__productos__item {
            &__name {
              opacity: 1;
              -webkit-transition: 0.35s ease-in-out opacity;
              -moz-transition: 0.35s ease-in-out opacity;
              -ms-transition: 0.35s ease-in-out opacity;
              -o-transition: 0.35s ease-in-out opacity;
              transition: 0.35s ease-in-out opacity;
            }

            &__tab {
              background-color: black;
              -webkit-transition: 0.35s ease-in-out background-color;
              -moz-transition: 0.35s ease-in-out background-color;
              -ms-transition: 0.35s ease-in-out background-color;
              -o-transition: 0.35s ease-in-out background-color;
              transition: 0.35s ease-in-out background-color;
            }
          }
        }
      }
    }

    &__modelos {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
      align-items: center;
      width: calc(100% - 300px);
      height: 100%;
      overflow: overlay;
      gap: 50px;
      padding: 0px 15px 15px 15px;

      &__item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        width: 100%;
        height: 600px;
        text-decoration: none;
        gap: 15px;

        &__miniatura {
          width: 100%;
          height: 600px;
          background-color: rgb(0, 0, 0, 0.75);

          &__image {
            opacity: 0;
            filter: brightness(1);
            width: 100%;
            height: 100%;
            object-fit: cover;
            -webkit-transition:
              0.35s ease-in-out filter,
              0.35s ease-in-out opacity;
            -moz-transition:
              0.35s ease-in-out filter,
              0.35s ease-in-out opacity;
            -ms-transition:
              0.35s ease-in-out filter,
              0.35s ease-in-out opacity;
            -o-transition:
              0.35s ease-in-out filter,
              0.35s ease-in-out opacity;
            transition:
              0.35s ease-in-out filter,
              0.35s ease-in-out opacity;
          }

          @media (hover: hover) {
            &:hover {
              & .indice__content__modelos__item__miniatura {
                &__image {
                  filter: brightness(0.5);
                  -webkit-transition:
                    0.35s ease-in-out filter,
                    0.35s ease-in-out opacity;
                  -moz-transition:
                    0.35s ease-in-out filter,
                    0.35s ease-in-out opacity;
                  -ms-transition:
                    0.35s ease-in-out filter,
                    0.35s ease-in-out opacity;
                  -o-transition:
                    0.35s ease-in-out filter,
                    0.35s ease-in-out opacity;
                  transition:
                    0.35s ease-in-out filter,
                    0.35s ease-in-out opacity;
                }
              }
            }
          }
        }

        &__name {
          color: black;
          font-size: 20px;
        }
      }
    }
  }

  @media screen and (max-width: 1050px) and (min-height: 600px) {
    &__header {
      padding: 10px;
      height: 62px;

      &__logo {
        font-size: 18px;
        line-height: 14px;
      }
    }

    &__content {
      flex-direction: column;
      height: calc(100% - 62px);

      &__productos {
        width: 100%;
        height: auto;
        justify-content: flex-start;
        align-items: center;
      }

      &__modelos {
        grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));
        width: 100%;
        gap: 75px;

        &__item {
          height: 65dvh;

          &__miniatura {
            height: 100%;
          }
        }
      }
    }
  }

  @media screen and (max-height: 600px) {
    &__header {
      padding: 10px;
      height: 62px;

      &__logo {
        font-size: 18px;
        line-height: 14px;
      }
    }

    &__content {
      height: calc(100% - 62px);

      &__modelos {
        &__item {
          height: 65dvh;

          &__miniatura {
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
